// DiCC — comportamenti condivisi, senza dipendenze. L'e-commerce resta nativo Shopify:
// qui solo quantità +/-, barra d'acquisto fissa su telefono, focus sull'esito dei moduli, accesso riservato.
(() => {
  // Quantità: bottoni − / + accanto al campo.
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty]');
    if (!btn) return;
    const input = btn.parentElement.querySelector('input[type="number"]');
    const next = Number(input.value || 1) + Number(btn.dataset.qty);
    input.value = Math.min(Number(input.max || 99), Math.max(Number(input.min || 1), next));
  });

  // Barra fissa: compare dopo aver superato il primo "Compra ora" e quando nessuno è a schermo.
  const bar = document.querySelector('[data-buy-bar]');
  const anchors = [...document.querySelectorAll('[data-buy-anchor]')];
  if (bar && anchors.length) {
    const update = () => {
      const vh = innerHeight;
      const onScreen = anchors.some((a) => { const r = a.getBoundingClientRect(); return r.bottom > 0 && r.top < vh; });
      const pastFirst = anchors[0].getBoundingClientRect().bottom < 0;
      bar.classList.toggle('is-visible', pastFirst && !onScreen);
    };
    addEventListener('scroll', update, { passive: true }); // due getBoundingClientRect: costo trascurabile
    addEventListener('resize', update);
    update();
  }

  // Dopo l'invio di un modulo la pagina si ricarica: porta l'attenzione sull'esito.
  const result = document.querySelector('[data-autofocus]');
  if (result) {
    result.scrollIntoView({ block: 'center' });
    result.focus({ preventScroll: true });
  }

  // Accesso riservato (pagina password).
  const dialog = document.querySelector('[data-owner-dialog]');
  if (dialog) {
    document.querySelector('[data-owner-open]')?.addEventListener('click', () => dialog.showModal());
    dialog.querySelector('[data-owner-close]')?.addEventListener('click', () => dialog.close());
    if (dialog.querySelector('[data-has-error]')) dialog.showModal();
  }
})();
